// src/components/elements/UserAccountIcon.js
import React, { useState } from 'react';
import IconEffectWrapper from './IconEffectWrapper';
import UserAccountModal from '../modals/UserAccountModal';
import useUserStore from '../../contexts/useUserStore';

const UserAccountIcon = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isAuthenticated } = useUserStore();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <IconEffectWrapper onClick={openModal}>
        <div className="relative">
          <i className={`bi bi-person-circle text-lg ${isAuthenticated ? 'text-[var(--brandsecondary)]' : 'text-gray-600'}`}></i>
          {isAuthenticated && (
            <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-[var(--brandsecondary)] rounded-full border border-white"></span>
          )}
        </div>
      </IconEffectWrapper>
      <UserAccountModal isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default UserAccountIcon;
